<script>
    import { Icon, Button } from "./index";
</script>

<div class="demo-icon source">

<Icon class="el-icon-edit" />
<Icon class="el-icon-share" />
<Icon class="el-icon-delete" />
<br>
<br>
<Icon icon="el-icon-edit" />
<Icon icon="el-icon-share" />
<Icon icon="el-icon-delete" />
<br>
<br>
<Icon icon="edit" />
<Icon icon="share" />
<Icon icon="delete" />
<br>
<br>
<Icon name="edit" />
<Icon name="share" />
<Icon name="delete" />
<br>
<br>
<Button type="primary" icon="el-icon-search">搜索</Button>

</div>
<style>
    
</style>